import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

const useStyles = makeStyles(() => ({
	talkTimeBar: {
		display: "flex",
		height: "28px",
		borderRadius: "8px",
		overflow: "hidden"
	},
	talkTimeCloserSegment: {
		backgroundColor: themeColors.colors.system.purple[600]
	},
	talkTimeLeadSegment: {
		backgroundColor: themeColors.colors.system.beige[400]
	},
	talkTimeDot: {
		width: "10px",
		height: "10px",
		borderRadius: "50%",
		display: "inline-block"
	},
	talkTimeCloserLabel: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-end",
		fontSize: "0.7rem",
		fontWeight: 700,
		height: "100%",
		paddingRight: "8px"
	},
	talkTimeLeadLabel: {
		display: "flex",
		alignItems: "center",
		justifyContent: "flex-start",
		fontSize: "0.7rem",
		fontWeight: 700,
		height: "100%",
		paddingLeft: "8px"
	}
}))

export default useStyles
